import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  Divider,
  Tabs,
  Tab,
  Chip,
  IconButton,
  Checkbox,
  FormGroup,
  FormControlLabel,
  MenuItem,
  Select,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import LockResetIcon from '@mui/icons-material/LockReset';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddIcon from '@mui/icons-material/Add';
import LeftNavbar from './LeftNav';
import TopNav from './Navbar';
import Breadcrumb from './BreadCrump';
import axios from 'axios';

// Helper TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const Profile = () => {
  const [user, setUser] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [error, setError] = useState('');
  const token = localStorage.getItem('token');

  const [preferredFormats, setPreferredFormats] = useState([]);

  const handleFormatChange = (e, format) => {
    if (e.target.checked) {
      setPreferredFormats((prev) => [...prev, format]);
    } else {
      setPreferredFormats((prev) => prev.filter((item) => item !== format));
    }
  };

  useEffect(() => {
    if (!token) return;

    fetch('http://196.216.9.34:5020/api/users/me', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => (data.message ? setError(data.message) : setUser(data)))
      .catch(() => setError('Failed to load user data'));
      
     
  }, [token]);

  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const [editMode, setEditMode] = useState(false);
  const [passwordData, setPasswordData] = useState({
    current: '',
    new: '',
    confirm: '',
  });

  const [interestInput, setInterestInput] = useState('');
  const [interests, setInterests] = useState([]);
  const [learningGoals, setLearningGoals] = useState('');
  const [availableTime, setAvailableTime] = useState('');
  const [learningDuration, setLearningDuration] = useState('');

  const [username, setUsername] = useState('');
  const [editUsername, setEditUsername] = useState(false);

  useEffect(() => {
    fetch('/api/profile', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setProfile({
          name: data.username || '',
          email: data.email || '',
          phone: data.phone || ''
        });
        setInterests(data.interests || []);
        setLearningGoals(data.learningGoals || '');
        setPreferredFormats(data.preferredFormats || []);
        setAvailableTime(data.availableTime || '');
        setLearningDuration(data.learningDuration || '');
      })
      .catch(err => console.error('Failed to fetch profile:', err));
  }, []);
  

  const handleAddInterest = () => {
    const trimmed = interestInput.trim();
    if (trimmed && !interests.includes(trimmed)) {
      setInterests([...interests, trimmed]);
    }
    setInterestInput('');
  };

  const handleDeleteInterest = (interestToDelete) => {
    setInterests(interests.filter((interest) => interest !== interestToDelete));
  };

  const handleSave = () => {
    fetch('/api/profile', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        username: profile.name,
        phone: profile.phone,
        interests,
        learningGoals,
        preferredFormats,
        availableTime,
        learningDuration
      })
    })
      .then(res => {
        if (!res.ok) throw new Error('Failed to update profile');
        return res.json();
      })
      .then(() => {
        setEditMode(false);
        alert('Profile updated successfully');
      })
      .catch(err => {
        console.error(err);
        alert('There was an error saving your profile');
      });
  };
  

  const handlePasswordChange = () => {
    if (passwordData.new !== passwordData.confirm) {
      alert('Passwords do not match');
      return;
    }

    axios
      .post('http://196.216.9.34:5020/api/user/change-password', passwordData)
      .then(() => {
        alert('Password changed successfully!');
        setPasswordData({ current: '', new: '', confirm: '' });
      })
      .catch((err) => {
        alert('Failed to change password');
        console.error(err);
      });
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Profile" />

          <Typography variant="h4" fontWeight="bold" sx={{ color: '#ff6600', mb: 4 }}>
            <AccountCircleIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Profile
          </Typography>

          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            aria-label="Profile Tabs"
            textColor="primary"
            indicatorColor="primary"
            sx={{ mb: 4 }}
          >
            <Tab label="Profile Overview" id="profile-tab-0" aria-controls="profile-tabpanel-0" />
            <Tab label="Edit Profile" id="profile-tab-1" aria-controls="profile-tabpanel-1" />
          </Tabs>

          {/* Tab 1: Profile Overview (read-only display) */}
          <TabPanel value={tabIndex} index={0}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Personal Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Full Name
                    </Typography>
                    <Typography variant="body1">{profile.name || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Email
                    </Typography>
                    <Typography variant="body1">{profile.email || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Phone
                    </Typography>
                    <Typography variant="body1">{profile.phone || '-'}</Typography>
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom>
                  Username
                </Typography>
                <Typography variant="body1">{username || '-'}</Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom>
                  Interests
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {interests.length > 0 ? (
                    interests.map((item, i) => (
                      <Chip key={i} label={item} color="primary" variant="outlined" />
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No interests added.
                    </Typography>
                  )}
                </Box>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom>
                  Learning Goals
                </Typography>
                <Typography variant="body1" whiteSpace="pre-line">
                  {learningGoals || '-'}
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom>
                  Preferred Content Formats
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {preferredFormats.length > 0 ? (
                    preferredFormats.map((format, i) => (
                      <Chip key={i} label={format} color="secondary" variant="outlined" />
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      None selected.
                    </Typography>
                  )}
                </Box>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom>
                  Available Time Per Week
                </Typography>
                <Typography variant="body1">{availableTime || '-'}</Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" gutterBottom>
                  Target Learning Duration
                </Typography>
                <Typography variant="body1">{learningDuration || '-'}</Typography>
              </CardContent>
            </Card>
          </TabPanel>

          {/* Tab 2: Edit Profile (your existing editable form UI) */}
          <TabPanel value={tabIndex} index={1}>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Typography variant="h6">Personal Details</Typography>
                      <IconButton onClick={() => setEditMode(!editMode)} sx={{ color: '#ff6600' }}>
                        {editMode ? <SaveIcon onClick={handleSave} /> : <EditIcon />}
                      </IconButton>
                    </Stack>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Full Name"
                          fullWidth
                          disabled={!editMode}
                          value={profile.name}
                          onChange={(e) => setProfile({ ...profile, name: e.target.value })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Email"
                          fullWidth
                          disabled={!editMode}
                          value={profile.email}
                          onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Phone"
                          fullWidth
                          disabled={!editMode}
                          value={profile.phone}
                          onChange={(e) => setProfile({ ...profile, phone: e.target.value })}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Change Username Section */}
                <Card sx={{ mt: 4 }}>
                  <CardContent>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: 2 }}
                    >
                      <Typography variant="h6">Change Username</Typography>
                      <IconButton
                        onClick={() => {
                          if (editUsername) {
                            // Save username immediately (update profile.name)
                            setProfile((prev) => ({ ...prev, name: username }));
                            setEditUsername(false);
                          } else setEditUsername(true);
                        }}
                        sx={{ color: '#ff6600' }}
                      >
                        {editUsername ? <SaveIcon /> : <EditIcon />}
                      </IconButton>
                    </Stack>
                    <TextField
                      label="Username"
                      fullWidth
                      value={username}
                      disabled={!editUsername}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </CardContent>
                </Card>

                {/* Change Password Section */}
                <Card sx={{ mt: 4 }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      <LockResetIcon
                        sx={{ mr: 1, verticalAlign: 'middle', color: '#ff6600' }}
                      />
                      Change Password
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          label="Current Password"
                          type="password"
                          fullWidth
                          value={passwordData.current}
                          onChange={(e) =>
                            setPasswordData({ ...passwordData, current: e.target.value })
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="New Password"
                          type="password"
                          fullWidth
                          value={passwordData.new}
                          onChange={(e) =>
                            setPasswordData({ ...passwordData, new: e.target.value })
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Confirm Password"
                          type="password"
                          fullWidth
                          value={passwordData.confirm}
                          onChange={(e) =>
                            setPasswordData({ ...passwordData, confirm: e.target.value })
                          }
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          onClick={handlePasswordChange}
                          sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: '#e65c00' } }}
                        >
                          Update Password
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                {/* Interests & Preferences Section */}
                <Card sx={{ mt: 4 }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Interests and Preferences
                    </Typography>

                    <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap' }}>
                      {interests.map((interest, index) => (
                        <Chip
                          key={index}
                          label={interest}
                          onDelete={() => handleDeleteInterest(interest)}
                          sx={{ bgcolor: '#ffcc80', color: '#4e342e' }}
                        />
                      ))}
                    </Stack>

                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ mb: 3, flexWrap: 'wrap' }}
                      alignItems="center"
                    >
                      <TextField
                        label="Add Interest"
                        value={interestInput}
                        onChange={(e) => setInterestInput(e.target.value)}
                        size="small"
                      />
                      <Button
                        variant="contained"
                        onClick={handleAddInterest}
                        startIcon={<AddIcon />}
                        sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: '#e65c00' } }}
                      >
                        Add
                      </Button>
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Learning Goals
                    </Typography>
                    <TextField
                      multiline
                      rows={3}
                      fullWidth
                      value={learningGoals}
                      onChange={(e) => setLearningGoals(e.target.value)}
                      placeholder="Describe your learning goals"
                    />

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Preferred Content Formats
                    </Typography>
                    <FormGroup row>
                      {['Video', 'Text', 'Interactive', 'Audio'].map((format) => (
                        <FormControlLabel
                          key={format}
                          control={
                            <Checkbox
                              checked={preferredFormats.includes(format)}
                              onChange={(e) => handleFormatChange(e, format)}
                            />
                          }
                          label={format}
                        />
                      ))}
                    </FormGroup>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Available Time Per Week
                    </Typography>
                    <Select
                      fullWidth
                      value={availableTime}
                      onChange={(e) => setAvailableTime(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {['< 2 hours', '2-5 hours', '5-10 hours', '> 10 hours'].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>

                    <Divider sx={{ my: 2 }} />

                    <Typography variant="subtitle1" gutterBottom>
                      Target Learning Duration
                    </Typography>
                    <Select
                      fullWidth
                      value={learningDuration}
                      onChange={(e) => setLearningDuration(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {['1 month', '3 months', '6 months', '1 year'].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
